import { countries } from "../../../vars/countries";

export const countryDictionary = {
  Poland: "Polska",
  "United Kingdom": "Wielka Brytania",
  Austria: "Austria",
  Belgium: "Belgia",
  Bulgaria: "Bułgaria",
  "Czech Republic": "Czechy",
  Finland: "Finlandia",
  France: "Francja",
  Germany: "Niemcy",
  Hungary: "Węgry",
  Ireland: "Irlandia",
  Italy: "Włochy",
  Latvia: "Łotwa",
  Netherlands: "Niderlandy",
  Portugal: "Portugalia",
  Romania: "Rumunia",
  "Russian Federation": "Rosja",
  Spain: "Hiszpania",
  Sweden: "Szwecja",
  Switzerland: "Szwajcaria",
  Ukraine: "Ukraina",
  Russia: "Rosja",
  Norway: "Norwegia",
};

export const translatedCountries = countries.map((country) => ({
  iso: country.iso,
  name: countryDictionary[country.name] || country.name,
}));

export const typeDictionary = {
  "Authorised Dealer": "Autoryzowany sprzedawca",
  "Authorised Distributor": "Autoryzowany dystrybutor",
  "Authorised Stocking Dealer": "Authorised Stocking Dealer",
  "Pedders Warehouse": "Magazyn Pedders",
};

export const specialisationDictionary = {};
